export const containsOnlyNumbersChars = (str: string) => {
  return /^\d+$/.test(str);
};
